export default __webpack_public_path__ + "static/about-us-min-20d05f72370270659a49f0393db820df.jpeg";